import React from 'react'
import { Button, Card, CardBody, Col, Input, Row } from 'reactstrap';
import { ListCardsRoles } from '../../../components/cards/ListCardsRoles';
import { ModalRol } from '../../../components/roles/ModalRol';
import { useRoles } from '../../../hooks/usersRols/useRoles';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import '../../../components/roles/StyleRol.css'
export const ComponentRoles = () => {
 
	const {
		modalTitle, modalRoles, methodRoles, closeDialog,
        //ROLES MODEL
        listRoles, listViews, loading, 
        handleInputChange, handleSelectValues,
        name, ids_views,    validationsRole,     
        listRolesData,
        
        //ROLES METHODS
        saveCreateRol,handleCreateRoles,
        handleUpdate, saveUpdateRole,
        handleDelete, saveDeleteRol,
		handleViewViews,

		// ? SEARCH AND DOWNLOAD EXCEL
		handleExcelRol, loadingExcel,
		handleSearchRol, searchIndicationsP,
		handleClearRol,

		//? DELETE DIALOG
		showDeleteAlert, modalAlert,
		closeDeleteAlert
        
	} = useRoles();

	const headerStyle = {
		backgroundColor: "#1d5b83",
		color: "#fff",
		fontWeight: "bold",
		fontSize: "11px",
		borderRight: "1px solid #fff",
		borderBottom: "2px solid #fff",
	};

	const cellStyle = {
		fontSize: "11px",
		padding: "8px",
		textAlign: "center",
		fontFamily: "Montserrat, sans-serif",
		lineHeight: "1.8",
		color: "#353535"
	};

	const centerStyle = {
		...cellStyle,
		textAlign: "center",
	};

	const actions = (rowData) => {

		return (
			<div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
				<button
					onClick={() => handleViewViews(rowData.id_role)}
					title="Previsualizar roles y vistas"
					className="btnTableAction"
					style={{
						backgroundColor: "#0daabf"
					}}
				>
					<i className="fa fa-eye"></i>
				</button>

				<Button
					size="sm"
					onClick={() => handleUpdate(rowData.id_role)}
					title="Editar"
					className="btnTableAction"
				>
					<i className="fa fa-edit iconTableAction"></i>
				</Button>

				<button
					onClick={() => handleDelete(rowData.id_role)}
					title="Eliminar"
					className="btnTableAction"
					style={{
						backgroundColor: "#bf0d0d"
					}}
				>
					<i className="fa fa-trash"></i>
				</button>
			</div>
		);
	};


    return (
		<>
			<Card>
				<CardBody className='p-1'>
					<TitleDataTable
						titleTable="Listado de roles"
						buttonActions={handleExcelRol}
						titleButton="Excel de roles"
						isDisbled={loadingExcel}
						loadingIsDisabled={loadingExcel}
						titleCreate="Crear roles"
						buttonActionsCreate={handleCreateRoles}
						actionInput={handleSearchRol}
						valueFilter={searchIndicationsP}
						filterLocalStorage={true}
						cleanFilterLocalStorage={handleClearRol}
					/>

					<div className="table-responsive">
						<DataTable
							value={listRoles}
							paginator
							rows={10}
							responsiveLayout="scroll"
							rowsPerPageOptions={[10, 50, 100]} 
							className="data-table p-datatable-striped p-datatable-sm"
							emptyMessage={
								<div className="text-center">
									<img
										src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
										style={{ width: "32%" }}
										alt="Sin resultados"
									/>
									<br />
									<p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
										No se encontraron resultados.
									</p>
								</div>
							}
						>
							<Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
							<Column 
								field="name"
								header="Nombre" 
								sortable
								body={(rowData) => (
									<span style={{ fontWeight: "bold" }}>
										{rowData.name}
									</span>
								)}
								headerStyle={headerStyle} 
								style={cellStyle} 
							/>
							<Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
						</DataTable>
					</div>
					
				</CardBody>
			</Card>
			<ModalRol
				{
					...{
						modalRoles, closeDialog, modalTitle, methodRoles, loading,
						handleInputChange, handleSelectValues, validationsRole,
						listViews, listRolesData,
						name, ids_views, 
						saveCreateRol, saveUpdateRole, saveDeleteRol
					}
				}
			/>

			{showDeleteAlert && (
				<AlertDataTable
					titleAlert="Eliminar rol"
					visibleAlert={modalAlert}
					onHideAlert={closeDeleteAlert}
					sizeAlert="medium-dialog delete-method"
					messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el rol, con sus respectivas asignaciones de vistas?"
					alert1={true}
					titleAlert1={name}
					buttonAcept
					titleNotLoading="Eliminar"
					titleDanger="Cancelar"
					actionAcept={saveDeleteRol}
				/>
			)}
			
		</>
    )
}
